import { useEffect, useRef } from "react";

/**
 * Reveal — subtle scroll-triggered fade/translate.
 * Usage: <Reveal delay={120}><h1>...</h1></Reveal>
 */
const Reveal = ({ children, delay = 0, as: Tag = "div", className = "", ...rest }) => {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        if (typeof IntersectionObserver === "undefined") {
            el.classList.add("is-visible");
            return;
        }
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setTimeout(() => {
                            entry.target.classList.add("is-visible");
                        }, delay);
                        io.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
        );
        io.observe(el);
        return () => io.disconnect();
    }, [delay]);

    return (
        <Tag ref={ref} className={`reveal ${className}`} {...rest}>
            {children}
        </Tag>
    );
};

export default Reveal;
